<template>
    <div>
      <v-overlay :value="overlay" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <v-icon class="mb-1">mdi-package-variant-closed-check</v-icon>
            Embarques
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-col cols="2">
            <v-text-field
              v-model="desde"
              @click:append="cargarLista()"
              
              @change="cargarLista()"
              small
              type="date"
              append-icon="mdi-magnify"
              label="Desde"
              single-line
              class="mt-5 mx-1"
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="hasta"
              @click:append="cargarLista()"
              small
              
              type="date"
              clearable
              @change="cargarLista()"
              append-icon="mdi-magnify"
              label="Hasta"
              single-line
              class="mt-5 mx-2"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              class="mt-4"
              v-model="soloEncargos"
              label="Solamente encargos"
              @change="cargarLista()"
            ></v-checkbox>
          </v-col>            
            
           
         
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat>
          <v-col cols="2">
          <v-btn small color="primary" @click="exportar()"
            ><v-icon left>mdi-file-excel</v-icon>Exportar</v-btn
          ></v-col>
          
          <v-col cols="3">
            <v-autocomplete
              v-model="searchScli"
              label="Subcliente"
              class="mt-5 mx-2"
              :items="sclientes"
              item-value="ENTE_ID"
              item-text="ENTE_NOMBRE"
              @keyup.enter="cargarLista()"
              @click:append="cargarLista()"
              @change="cargarLista()"
              clearable
            ></v-autocomplete>
          </v-col> 
          <v-col cols="3">
            <v-text-field
              v-model="searchFinca"
              append-icon="mdi-magnify"
              label="Finca"
              single-line
              class="mt-5 mx-2"
              @keyup.enter="cargarLista()"
              @click:append="cargarLista()"
              @change="cargarLista()"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="searchAwb"
              append-icon="mdi-magnify"
              label="AWB"
              single-line
              class="mt-5 mx-2"
              clearable
              @keyup.enter="cargarLista()"
              @click:append="cargarLista()"
              @change="cargarLista()"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="lista"
          :items-per-page="itemsPerPage"
          :loading="loadingTable"
          class="elevation-1 mx-4"
        >
        </v-data-table>
      </v-card>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  import Vue from "vue";
  
  export default {
    name: "Encargos",
    data: () => ({
      overlay: false,
      headers: [
        { text: "FECHA", value: "FECHA" },
        { text: "AWB", value: "AWB" },
        { text: "Finca", value: "FINCA_NOMBRE" },
        { text: "Subcliente", value: "SCLIENTE_NOMBRE" },
        { text: "Cajas", value: "CAJAS_CONF" , align: "right"},
        { text: "Piezas", value: "PIEZAS_CONF" , align: "right"},
        { text: "Cajas coordinadas", value: "BOXES_COORD" , align: "right"},
        { text: "Cajas recibidas", value: "CAJAS_REC" , align: "right"},
        
      ],
  
      requiredRule: [(v) => !!v || "El campo es requerido"],
      emailRules: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Ingrese un Email válido",
      ],
      lista: [],
      options: {},
      dialog: false,
      notifications: false,
      sound: true,
      widgets: true,
      desde: "",
      hasta: "",
      searchAwb: "",
      searchScli: "",
      searchFinca: "",
      soloEncargos: false,
      itemsPerPage: 20,
    }),
    computed: {
      ...mapState("master", ["loadingTable", "user"]),
      ...mapGetters("access", [""]),
    },
    methods: {
      ...mapMutations("master", [
        "setUrl",
        "setOverlay",
        "setMenu",
        "setLoadingTable",
        "setTitleToolbar",
      ]),
  
      ...mapActions("master", ["requestApi", "alertNotification"]),
  
      cargarLista() {
        this.overlay = true;
        this.setLoadingTable(true);
        this.setUrl("api/historial_embarques_encargo");
        this.requestApi({
          method: "GET",
          data: {
            awb: this.searchAwb,
            desde: this.desde,
            hasta: this.hasta,
            scliente: this.searchScli,            
            finca: this.searchFinca,            
            solo_encargos: this.soloEncargos === true ? 1 : "",
          },
        })
          .then((res) => {
            this.lista = res.data.lista;
            this.sclientes = res.data.sclientes;
            //this.pageCount = 10;
            this.setLoadingTable(false);
            this.overlay = false;
          })
          .catch(() => {})
          .finally(() => {
            this.setLoadingTable(false);
            this.overlay = false;
          });
      },
  
      exportar() {
        this.overlay = true;
        this.setUrl("api/historial_embarques_encargo_exportar");
  
        this.requestApi({
          method: "POST",
          data: {
            awb: this.searchAwb,
            desde: this.desde,
            hasta: this.hasta,
            scliente: this.searchScli,
            solo_encargos: this.soloEncargos === true ? 1 : "",
          },
        })
          .then((res) => {
            let a = document.createElement("a");
            a.href = "data:application/xml;base64," + res.data.datos;
            a.download = res.data.archivo;
            a.click();
            //this.alertNotification({ param: { html: res.data.msg } });
            this.overlay = false;
          })
          .catch((res) => {
            this.overlay = false;
          })
          .finally((res) => {
            this.overlay = false;
          });
      },
    },
  
    mounted() {
      document.title = "Sistema de carga";
      this.setTitleToolbar("Historial de embarques");
      this.cargarLista();
    },
  };
  </script>
  